module.exports = __webpack_public_path__ + "static/media/image6.4917d4f6.JPG";